// Згенеровано Tools/gen_frontend.py з визначень модулів. Не редагувати вручну: зміни моделі — у визначенні модуля
// Solutions/Metadata/<Група>/<Модуль>/module.definition.json (каталог Design — похідний), власні подання — у views/ пакета.

import type { IRecordTypeDefinition } from '@platform/core/types';
import { assembleViewSet } from '@platform/core/lib/assembleViewSet';
import dtprotoEntity from './entities/dtproto.json';
import dtprotoMenu from '../pages/dtproto/menu.json';
import dtprotoFullForm from '../pages/dtproto/forms/full.json';
import dtprotoContextForm from '../pages/dtproto/forms/context.json';
import dtprotoMiniForm from '../pages/dtproto/forms/mini.json';
import dtprotoLookupForm from '../pages/dtproto/forms/lookup.json';
import dtprotoTableView from '../pages/dtproto/views/table.json';
import dtprotoStagesView from '../pages/dtproto/views/stages.json';
import dtprotoCardsView from '../pages/dtproto/views/cards.json';
import dtprotoInlineView from '../pages/dtproto/views/inline.json';
import dtprotoBacklogView from '../pages/dtproto/views/backlog.json';
import dtprotoSplitView from '../pages/dtproto/views/split.json';
import dtprotoCalendarView from '../pages/dtproto/views/calendar.json';
import dtprotoDashboardView from '../pages/dtproto/views/dashboard.json';

/** Тип запису «Прототип» зі сторінками пакета: меню, форми та подання з pages/dtproto/. */
export const dtprotoDefinition: IRecordTypeDefinition = {
  ...dtprotoEntity,
  views: assembleViewSet({
      table: dtprotoTableView,
      stages: dtprotoStagesView,
      cards: dtprotoCardsView,
      inline: dtprotoInlineView,
      backlog: dtprotoBacklogView,
      split: dtprotoSplitView,
      calendar: dtprotoCalendarView,
      dashboard: dtprotoDashboardView,
  }),
  form: dtprotoFullForm,
  forms: { full: dtprotoFullForm, context: dtprotoContextForm, mini: dtprotoMiniForm, lookup: dtprotoLookupForm },
  menu: dtprotoMenu,
} as IRecordTypeDefinition;
